<template>
    <div>
        <el-card class="form-container" shadow="never" style="margin-top: 5px">
            <el-form :inline="true" size="small" label-width="140px">
                <el-form-item label="用户Id：" label-width="180px">
                    <el-input v-model="queryOrderData.userId"></el-input>
                </el-form-item>
                <el-col :span="8">
                    <span>创建日期：</span>
                    <el-date-picker
                        v-model="queryOrderData.createDt"
                        type="daterange"
                        :clearable="true"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :span="8">
                    <span>支付日期：</span>
                    <el-date-picker
                        v-model="queryOrderData.payDt"
                        type="daterange"
                        :clearable="true"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :span="8">
                    <span>完成日期：</span>
                    <el-date-picker
                        v-model="queryOrderData.updateDt"
                        type="daterange"
                        :clearable="true"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-col>
                <el-form-item label="状态">
                    <el-select v-model="queryOrderData.status" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="创建" :value=0></el-option>
                        <el-option label="完成" :value=1></el-option>
                        <el-option label="苹果待校验" :value=2></el-option>
                        <el-option label="关闭" :value=3></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="queryOrderData.type" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="微信" :value=0></el-option>
                        <el-option label="支付宝" :value=1></el-option>
                        <el-option label="苹果" :value=2></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="内容">
                    <el-select v-model="queryOrderData.name" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="永久会员" value="永久会员"></el-option>
                        <el-option label="月度会员" value="月度会员"></el-option>
                        <el-option label="年度会员" value="年度会员"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="金额">
                    <el-select v-model="queryOrderData.money" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="3.00" :value=3.00></el-option>
                        <el-option label="18.00" :value=18.00></el-option>
                        <el-option label="28.00" :value=28.00></el-option>
                        <el-option label="38.00" :value=38.00></el-option>
                        <el-option label="32.00" :value=32.00></el-option>
                        <el-option label="35.00" :value=35.00></el-option>
                        <el-option label="48.00" :value=48.00></el-option>
                        <el-option label="88.00" :value=88.00></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" class="sub-sub11">
                    <el-button type="primary" @click="searchOrder">查询</el-button>
                    <el-button type="primary" @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table border="" :data="orderList">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column label="订单id" prop="id" align="center"></el-table-column>
                <el-table-column label="用户id" prop="user_id" align="center"></el-table-column>
                <el-table-column label="购买内容" prop="name" align="center"></el-table-column>
                <el-table-column label="实付金额" prop="money" align="center"></el-table-column>
                <el-table-column label="支付类型" prop="type" align="center"></el-table-column>
                <el-table-column label="订单状态" prop="pay_status" align="center"></el-table-column>
                <el-table-column label="创建时间" prop="create_dt" align="center"></el-table-column>
                <el-table-column label="付款时间" prop="pay_dt" align="center"></el-table-column>
                <el-table-column label="完成时间" prop="update_dt" align="center"></el-table-column>

            </el-table>
            <el-pagination
                style="margin-top: 5px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30,50]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </el-card>
    </div>

</template>

<script>
import settingMix from '@/utils/mix/common-setting'
import {downloadDataBook, orderSearch} from "@/http/aiBookAdminApi";
import DateUtil from "@/utils/DateUtil";

export default {
    name: "AiBookOrder",
    mixins: [settingMix],
    data() {
        return {
            page: {
                size: 30,
                page: 1,
                totalElements: null
            },
            orderList: [],
            queryOrderData: {
                "userId": null,
                "createDt": null,
                "updateDt": null,
                "payDt": null,
                "status": null,
                "type": null,
                "name": null,
                "money": null,
                "page": 1,
                "size": 30
            }
        }
    },
    methods: {
        handleCurrentChange(page) {
            this.page.page = page;
            this.queryOrderData.page = page;
            this.searchOrder()
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.queryOrderData.size = size;
            this.searchOrder()
        },
        page1() {
            this.page.page = 1;
            this.queryOrderData.page = 1;
        },
        searchOrder() {
            this.queryOrderData.size = this.page.size;
            this.queryOrderData.page = this.page.page;
            if (this.queryOrderData.createDt != null) {
                this.queryOrderData.createDtStart = this.queryOrderData.createDt[0] === '' ? null : this.queryOrderData.createDt[0];
                this.queryOrderData.createDtEnd = this.queryOrderData.createDt[1] === '' ? null : this.queryOrderData.createDt[1];
            } else {
                this.queryOrderData.createDtStart = null;
                this.queryOrderData.createDtEnd = null;
            }
            if (this.queryOrderData.updateDt != null) {
                this.queryOrderData.updateDtStart = this.queryOrderData.updateDt[0] === '' ? null : this.queryOrderData.updateDt[0];
                this.queryOrderData.updateDtEnd = this.queryOrderData.updateDt[1] === '' ? null : this.queryOrderData.updateDt[1];
            } else {
                this.queryOrderData.updateDtStart = null;
                this.queryOrderData.updateDtEnd = null;
            }
            if (this.queryOrderData.payDt != null) {
                this.queryOrderData.payDtStart = this.queryOrderData.payDt[0] === '' ? null : this.queryOrderData.payDt[0];
                this.queryOrderData.payDtEnd = this.queryOrderData.payDt[1] === '' ? null : this.queryOrderData.payDt[1];
            } else {
                this.queryOrderData.payDtStart = null;
                this.queryOrderData.payDtEnd = null;
            }
            orderSearch(this.queryOrderData).then(resp => {
                this.orderList = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
            })
        },
        exportExcel() {
            let fileName = new Date().toLocaleString() + '团团订单.xlsx';
            downloadDataBook(
                '/order/excel',
                Object.assign(this.queryOrderData),
                fileName
            )
        },
    },
    created() {
        this.queryOrderData.createDt = DateUtil.getIntervalDate(1);
        this.searchOrder();
    },
}
</script>

<style scoped>

</style>
